const listDefaultPageActions = [
    {
        title: 'Add New',
        to: '/discount',
    },
];

export const listPageActions = (displayType, anyDisabled) => {
    switch (displayType) {
        case 'disabled':
            return [
                {
                    title: 'Show Active',
                    to: '/discounts',
                },
                ...listDefaultPageActions,
            ];
        case 'active':
        default:
            if (anyDisabled) {
                return [
                    {
                        title: 'Show Disabled',
                        to: '/discounts/disabled',
                    },
                    ...listDefaultPageActions,
                ];
            } else {
                return listDefaultPageActions;
            }
    }
};

export const editPageActions = [
    {
        title: 'Back',
        to: '/discounts',
    },
];
